export default __webpack_public_path__ + "static/media/avatar.99a5e14e.png";